import { FC, ReactNode } from 'react';
import { Container, Box } from '@mui/material';
import PimDataGrid from 'src/components/pimData/pimDataGrid';

declare interface Props {
  children?: ReactNode;
}

const PimDataContainer: FC<Props> = () => {
  return (
    <Box sx={{ mt: 6 }}>
      <Container maxWidth={'xl'}>
        <PimDataGrid />
      </Container>
    </Box>
  );
};

export default PimDataContainer;
